export default __webpack_public_path__ + "ccff6e1a477c29e66c999e504de8c7f1.gif";